module.exports = __webpack_public_path__ + "img/fondo-banner-principal.a84efe6d.png";